import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyDpm9XaJhi1gFMpQ_RiiQ3JMOsk88ErxEc',
  authDomain: 'productinfo-dev.firebaseapp.com',
  projectId: 'productinfo-dev',
  storageBucket: 'productinfo-dev.appspot.com',
  messagingSenderId: '287299351001',
  appId: '1:287299351001:web:73e3b4c431f48e6f4929c8',
  measurementId: 'G-4WRHBEWGY1',
};
const firebase = initializeApp(firebaseConfig);
export const auth = getAuth(firebase);
export const googleProvider = new GoogleAuthProvider();
export const firestore = getFirestore(firebase);
